import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Delete2LineIcon, Modal, message } from 'ui';
import { useDeletePasskey } from '../../queries';

export const useDeletePasskeyConfirmModal = () => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: deletePasskey } = useDeletePasskey();

  const confirm = useCallback(
    ({ passkeyId, passkeyName }: { passkeyId: string; passkeyName: string }) => {
      const handleDeletePasskey = async () => {
        await deletePasskey(
          { passkeyId },
          {
            onError() {
              message.error("Something went wrong. The passkey couldn't be deleted.");
            },
            onSuccess() {
              message.success('Passkey deleted successfully.');
            },
          },
        );
      };

      modal.confirm({
        content: 'Deleting this passkey means you’ll need to login differently next time.',
        icon: <Delete2LineIcon type="error" />,
        okText: 'Delete',
        onOk: handleDeletePasskey,
        title: t('Delete the passkey', { name: passkeyName }),
        type: 'error',
      });
    },
    [deletePasskey, modal, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
